<template>
  <v-app>
    <navigation/>
    <v-content>
      <router-view/>
    </v-content>
    <stacked-snackbar-container/>
    <notification-card/>
    <switch-user v-if="$configuration.allowSwitchUser"/>
  </v-app>
</template>

<script>
  import Navigation from './Navigation/Index';
  import StackedSnackbarContainer from './StackedSnackbarContainer';
  import NotificationCard from './NotificationCard';
  import SwitchUser from './SwitchUser';

  export default {
    components: { Navigation, StackedSnackbarContainer, NotificationCard, SwitchUser },
    mounted() {
      // Automatically create messaging configuration for user if one does not exist
      this.$services.messaging.get('/config')
        .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
  }
</style>
